import { render } from "./Locations.vue?vue&type=template&id=2fbc36ba&ts=true"
import script from "./Locations.vue?vue&type=script&lang=ts"
export * from "./Locations.vue?vue&type=script&lang=ts"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__